// src/pages/CategoryPage.jsx
import { useParams, Link } from 'react-router-dom';
import { tools } from '../toolData';

export default function CategoryPage() {
  const { category } = useParams();
  const filteredTools = tools.filter(tool => tool.category === category);

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-white">
      <h2 className="text-2xl font-bold text-blue-300 mb-6 text-center">
        {category} Tools
      </h2>

      {filteredTools.length > 0 ? (
        <div className="grid gap-6 sm:grid-cols-2">
          {filteredTools.map(tool => (
            <Link
              key={tool.id}
              to={`/${tool.id}`}
              className="block bg-gray-800 p-4 rounded shadow hover:bg-gray-700 transition text-center text-blue-200 text-lg font-medium"
            >
              {tool.name}
            </Link>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-center">No tools found in this category.</p>
      )}
    </div>
  );
}
